var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00016 0.924255C10.6821 0.924255 13.6668 3.90902 13.6668 7.59092C13.6668 11.2728 10.6821 14.2576 7.00016 14.2576C3.31826 14.2576 0.333496 11.2728 0.333496 7.59092C0.333496 3.90902 3.31826 0.924255 7.00016 0.924255ZM8.04183 4.67425C8.04183 4.09896 7.57546 3.63259 7.00016 3.63259C6.42487 3.63259 5.9585 4.09896 5.9585 4.67425C5.9585 5.24955 6.42487 5.71592 7.00016 5.71592C7.57546 5.71592 8.04183 5.24955 8.04183 4.67425ZM7.8335 8.00759V10.5076C7.8335 10.9678 7.4604 11.3409 7.00016 11.3409C6.53993 11.3409 6.16683 10.9678 6.16683 10.5076V8.00759C6.16683 7.54735 6.53993 7.17425 7.00016 7.17425C7.4604 7.17425 7.8335 7.54735 7.8335 8.00759Z",
    fill: "#6C7380"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f2151a36bdee26e31a92fe1e8f2a9e7f.svg";
export { ForwardRef as ReactComponent };